import { DeliveryNoteOrder } from './delivery-note-order.type';
import { DeliveryNoteSchedules } from './delivery-note-schedules.type';

export const DeliveryNoteTypes = {
  HOME: 'home',
  DELIVERY_POINT: 'delivery-point',
  ECO: 'eco',
} as const;

export type DeliveryNoteTypes = typeof DeliveryNoteTypes[keyof typeof DeliveryNoteTypes];

export interface DeliveryNote {
  type: DeliveryNoteTypes;
  title: string;
  address: string;
  city: string;
  zip: string;
  deliveryDate: string;
  schedules: DeliveryNoteSchedules;
  phone?: string;
  informations?: string;
  additionalInfos?: string;
  bagsCount: number;
  total: number;
  orders: DeliveryNoteOrder[];
}
